// extracted by mini-css-extract-plugin
export var header = "_ar-0";